import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import type { Article } from '@/mocks/articles';

function TrendingCard({ article, index }: { article: Article; index: number }) {
  return (
    <Link
      to={`/article/${article.id}`}
      className="group cursor-pointer flex flex-col bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 transition-all overflow-hidden animate-fadeInUp"
      style={{ animationDelay: `${index * 0.1}s`, opacity: 0 }}
    >
      <div className="relative overflow-hidden h-44">
        <img
          src={article.coverImage}
          alt={article.title}
          title={`${article.title} - 爆料网`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <span className="absolute top-2 left-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-label rounded whitespace-nowrap">
          {article.categoryName}
        </span>
        {article.isHot && (
          <span className="absolute top-2 right-2 w-6 h-6 flex items-center justify-center">
            <i className="ri-fire-fill text-accent-500 text-lg"></i>
          </span>
        )}
      </div>
      <div className="p-4 flex flex-col flex-1">
        <h3 className="font-label text-sm font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
          {article.title}
        </h3>
        <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3 flex-1">
          {article.excerpt}
        </p>
        <div className="flex items-center justify-between text-xs text-foreground-400 font-label">
          <span className="whitespace-nowrap">{new Date(article.publishedAt).toLocaleDateString('zh-CN')}</span>
          <span className="flex items-center gap-1 whitespace-nowrap">
            <i className="ri-eye-line"></i> {(article.views / 10000).toFixed(0)}万
          </span>
        </div>
      </div>
    </Link>
  );
}

export default function TrendingSection() {
  const trendingArticles = articles
    .filter((a) => a.isTrending || a.isHot)
    .slice(0, 8);

  return (
    <section className="py-14 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            热门爆料
          </h2>
          <i className="ri-fire-fill text-accent-500 text-xl"></i>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-product-shop="">
          {trendingArticles.map((article, index) => (
            <TrendingCard key={article.id} article={article} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}